"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonProfile = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const OktonPlatformProvider_1 = require("../../platform/OktonPlatformProvider");
const BranchesModal_1 = require("../BranchesModal");
const InvoicesModal_1 = require("../InvoicesModal");
const ProfileModal_1 = require("../ProfileModal");
const SettingsModal_1 = require("../SettingsModal");
const OktonProfile = ({ onLogout, onProfile, onInvoices, onChangeBranch, onSettings, }) => {
    const { user, client, features } = (0, OktonPlatformProvider_1.useOktonPlatform)();
    const [showInvoices, setShowInvoices] = react_2.default.useState(false);
    const [showBranches, setShowBranches] = react_2.default.useState(false);
    const [showProfile, setShowProfile] = react_2.default.useState(false);
    const [showSettings, setShowSettings] = react_2.default.useState(false);
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    if (!user)
        return null;
    const canProfile = features.profile !== false;
    const canSettings = true;
    const canInvoices = Boolean(features.billing && (onInvoices || (client === null || client === void 0 ? void 0 : client.getInvoices)));
    const canBranches = Boolean(features.branchSwitching && (onChangeBranch || ((client === null || client === void 0 ? void 0 : client.getBranches) && (client === null || client === void 0 ? void 0 : client.switchBranch))));
    function handleProfile() {
        if (onProfile)
            onProfile();
        else
            setShowProfile(true);
    }
    function handleSettings() {
        if (onSettings)
            onSettings();
        else
            setShowSettings(true);
    }
    function handleInvoices() {
        if (onInvoices)
            onInvoices();
        else if (client === null || client === void 0 ? void 0 : client.getInvoices)
            setShowInvoices(true);
    }
    function handleBranches() {
        if (onChangeBranch)
            onChangeBranch();
        else if ((client === null || client === void 0 ? void 0 : client.getBranches) && (client === null || client === void 0 ? void 0 : client.switchBranch))
            setShowBranches(true);
    }
    return (react_2.default.createElement(react_1.Flex, { align: "center" },
        react_2.default.createElement(react_1.Menu, { isLazy: true },
            react_2.default.createElement(react_1.MenuButton, null,
                react_2.default.createElement(react_1.Avatar, { size: "sm", name: user.name, src: user.avatarUrl })),
            react_2.default.createElement(react_1.MenuList, null,
                react_2.default.createElement(react_1.MenuGroup, { title: user.name },
                    react_2.default.createElement(react_1.MenuItem, { icon: react_2.default.createElement(react_1.Icon, { as: lu_1.LuCircleUserRound, fontSize: "22" }), onClick: handleProfile, isDisabled: !canProfile }, "Perfil"),
                    canInvoices && (react_2.default.createElement(react_1.MenuItem, { icon: react_2.default.createElement(react_1.Icon, { as: lu_1.LuReceiptText, fontSize: "22" }), onClick: handleInvoices }, "Faturas do Sistema")),
                    canBranches && (react_2.default.createElement(react_1.MenuItem, { icon: react_2.default.createElement(react_1.Icon, { as: lu_1.LuBuilding2, fontSize: "22" }), onClick: handleBranches }, "Trocar Filial")),
                    react_2.default.createElement(react_1.MenuItem, { icon: react_2.default.createElement(react_1.Icon, { as: lu_1.LuSettings2, fontSize: "22" }), onClick: handleSettings, isDisabled: !canSettings }, "Configura\u00E7\u00F5es da conta")),
                react_2.default.createElement(react_1.MenuDivider, null),
                react_2.default.createElement(react_1.MenuItem, { _hover: { bg } },
                    react_2.default.createElement(react_1.Button, { colorScheme: "blue", variant: "outline", size: "md", fontSize: "sm", onClick: onLogout, isFullWidth: true, isDisabled: !onLogout }, "Logout")))),
        react_2.default.createElement(ProfileModal_1.OktonProfileModal, { isOpen: showProfile, onClose: () => setShowProfile(false) }),
        react_2.default.createElement(SettingsModal_1.OktonSettingsModal, { isOpen: showSettings, onClose: () => setShowSettings(false) }),
        (client === null || client === void 0 ? void 0 : client.getInvoices) && (react_2.default.createElement(InvoicesModal_1.OktonInvoicesModal, { isOpen: showInvoices, onClose: () => setShowInvoices(false) })),
        (client === null || client === void 0 ? void 0 : client.getBranches) && (client === null || client === void 0 ? void 0 : client.switchBranch) && (react_2.default.createElement(BranchesModal_1.OktonBranchesModal, { isOpen: showBranches, onClose: () => setShowBranches(false) }))));
};
exports.OktonProfile = OktonProfile;
//# sourceMappingURL=index.js.map